import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Experience Workspace => pinnedContainer => ');

const fetch = createAction('fetch pinned containers', (channelId) => ({
  channelId,
}));

const fetchSuccess = createAction('successfully fetched pinned containers', (pinnedContainers) => ({
  pinnedContainers,
}));

const fetchFailure = createApiFailureAction('failed to fetch pinned containers');

export default {
  fetch,
  fetchSuccess,
  fetchFailure,
};
